export { shouldDisplayPriceDiscount } from './shouldDisplayPriceDiscount';

export { shouldDisplayChip } from './shouldDisplayChip';

export { determineChipColor } from './chipColor';

export { getDepositName } from './getDepositName';
